var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarStorageIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21920",
    "data-name": "\\uADF8\\uB8F9 21920",
    transform: "translate(-672 -1448)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28341",
    "data-name": "\\uC0AC\\uAC01\\uD615 28341",
    width: 44,
    height: 44,
    transform: "translate(672 1448)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21919",
    "data-name": "\\uADF8\\uB8F9 21919",
    transform: "translate(-0.225 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ambulance",
    transform: "translate(676 1449.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10340",
    "data-name": "\\uD328\\uC2A4 10340",
    d: "M32.723,9.5H14.691a2.674,2.674,0,0,0-2.616,2.727v1.837H9.459V12.617a1,1,0,0,0-2,0v1.447H5.341a1.621,1.621,0,0,0-1.558,1.113L1.223,22.3,1,22.8l.445.612v6.122a1.793,1.793,0,0,0,1.781,1.781h.557a4.225,4.225,0,0,0,8.237,0H24.6a4.225,4.225,0,0,0,8.237,0h1.224a1.378,1.378,0,0,0,1.391-1.391V12.283A2.857,2.857,0,0,0,32.723,9.5ZM5.564,16.012h6.567v5.677H3.5ZM7.9,32.6a2.338,2.338,0,1,1,2.282-2.337A2.341,2.341,0,0,1,7.9,32.6Zm0-6.623a4.235,4.235,0,0,0-4.118,3.339h-.39V23.636h8.738v5.677H12.02A4.282,4.282,0,0,0,7.9,25.974ZM28.66,32.6a2.338,2.338,0,1,1,2.282-2.337A2.3,2.3,0,0,1,28.66,32.6Zm4.786-3.284h-.612a4.282,4.282,0,0,0-4.118-3.339A4.235,4.235,0,0,0,24.6,29.313H14.079V12.227a.708.708,0,0,1,.668-.779H32.723a.761.761,0,0,1,.668.835v17.03Z",
    fill: "#343a40"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1224",
    "data-name": "\\uD0C0\\uC6D0 1224",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(705.45 1450.55)",
    fill: "#ff6a13"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarStorageIcon3);
export default __webpack_public_path__ + "static/media/CarStorageIcon3.44270a5eae5e1acf728eaebec130e90b.svg";
export { ForwardRef as ReactComponent };